export default [
    {
        path: '/wechatPub/sfvip/:payID',
        meta:{
            title: '微信安全支付'
        },
        component: (resolve) => require(['@/pages/wechatPub/sfvip'], resolve)
    },
    
]